module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-Landing-page.4374a528.jpg";